import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterValuesStrings } from '../pages/analytics.page';
import { useAppSelector } from '../../../store';

export interface AnalyticsFilterState {
	filters: FilterValuesStrings;
}

const defaultFilters: FilterValuesStrings = {
	districtIds: '',
	engagementTypes: '',
	duration: [null, null],
	schoolIds: '',
	programIds: '',
	serviceIds: '',
	providerIds: '',
	languages: '',
	engagementStatuses: '',
};

export const initialState: AnalyticsFilterState = {
	filters: defaultFilters,
};

export const analyticsFilterSlice = createSlice({
	name: 'analyticsFilter',
	initialState,
	reducers: {
		setFilters(state: AnalyticsFilterState, action: PayloadAction<FilterValuesStrings>) {
			state.filters = action.payload;
		},
		clearFilters(state: AnalyticsFilterState) {
			state.filters = defaultFilters;
		},
	},
});

export const { setFilters, clearFilters } = analyticsFilterSlice.actions;

export const useAnalyticsFilterSelector = () => useAppSelector((state) => state.analyticsFilter);
